import Swiper, { Navigation } from 'swiper';

function Promotions() {

  const slider = document.querySelectorAll('[data-js="gs-tile"]'),
        sliderContianer = document.getElementsByClassName('gs-tiles')[0];

  slider.forEach(element => {

    const ToShowTablet = element.getAttribute('data-slidesToShowTablet'),
          ToScrollTablet = element.getAttribute('data-slidesToScrollTablet'),
          ToShowDesktop = element.getAttribute('data-slidesToShowDesktop'),
          ToScrollDesktop = element.getAttribute('data-slidesToScrollDesktop'),
          ToShowMobile = element.getAttribute('data-slidesToShowMobile'),
          ToScrollMobile = element.getAttribute('data-slidesToScrollMobile');
        
    new Swiper(element, {
      passiveListeners: false,
      slidesPerView: 'auto',
      freeMode: true,
      spaceBetween: 20,
      direction: "horizontal",
      breakpointsInverse: true,
      watchOverflow: true,
      navigation: {
        nextEl: document.querySelector('.swiper-button-next'),
        prevEl: document.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        320: {
            freeMode: false,
            slidesPerView: ToShowMobile,
            slidesPerGroup: ToScrollMobile,
            spaceBetween: 5
        },
        768: {
            freeMode: false,
            slidesPerView: ToShowTablet,
            slidesPerGroup: ToScrollTablet,
            spaceBetween: 20
        },
        992: {
            freeMode: false,
            slidesPerView: ToShowDesktop,
            slidesPerGroup: ToScrollDesktop,
            spaceBetween: 20
        }
      },
      // on: {
      //   resize: function () {
      //     this.update();
      //   }
      // }
    });
  });
}

const promotion = new Promotions();
export { promotion };
